import { mapState } from 'vuex';
import get from 'lodash/get';
import set from 'lodash/set';
import cloneDeep from 'lodash/cloneDeep';
import CoreDtwinStateOutboundConfigsIec104Push from './outboundConfigs/iec104Push.vue';
const CONNECTOR_COMPONENT_MAP = {
  'bridge-IEC-60870-5-104-push': 'core-dtwin-state-outbound-configs-iec-104-push'
};
export default {
  name: 'CoreDtwinStateEditOutboundConfig',
  components: {
    CoreDtwinStateOutboundConfigsIec104Push
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    connectors: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled'])
  },
  created() {
    // reactivity does not work without this, no idea what the issue is
    this.$emit('input', cloneDeep(this.value));
  },
  methods: {
    get: get,
    getNumberOfValidConfigs() {
      // return number of configs that have a valid connectorId
      return get(this.value, 'properties.outboundConfiguration', []).filter(c => this.doesConnectorIdExist(c.connectorId)).length;
    },
    add(index) {
      const configs = get(this.value, 'properties.outboundConfiguration', []);
      configs.splice(index + 1, 0, {});
      const newValue = cloneDeep(this.value);
      set(newValue, 'properties.outboundConfiguration', configs);
      this.$emit('input', newValue);
    },
    remove(index) {
      // get configs
      const configs = get(this.value, 'properties.outboundConfiguration', []);
      // remove config at index
      configs.splice(index, 1);
      if (this.getNumberOfValidConfigs() === 0) {
        // if there are no valid configs left, add an empty one
        configs.push({});
      }
      const newValue = cloneDeep(this.value);
      set(newValue, 'properties.outboundConfiguration', configs);
      this.$emit('input', newValue);
    },
    getComponentForConnectorId(connectorId) {
      const connectorById = this.connectors.find(c => c.id === connectorId);
      return CONNECTOR_COMPONENT_MAP[(connectorById || {}).type];
    },
    doesConnectorIdExist(connectorId) {
      if (!connectorId) {
        // if config has no connectorId, it is a new config
        return true;
      }

      // return true if connectorId exists in list of connectors
      return this.connectors.some(c => c.id === connectorId);
    }
  }
};